import React, { useState,useCallback } from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Search as SearchIcon, QrCode as QrCodeIcon, LocationOn as LocationOnIcon } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

//import qrIcon from '../assets/images/cat_qr.png'; 
import AsignarUbicacionPaciente from './AsignarUbicacionPaciente';
import BusquedaCamaraPaciente from './BusquedaCamaraPaciente';

import qrIcon from '../assets/images/code.gif'; 


const PRIMARY_COLOR = '#4f46e5';
const SUCCESS_COLOR = '#10b981';
const SECONDARY_COLOR = '#6b7280';
const WARNING_COLOR = '#f59e0b'; // Usaremos un color para el botón de Asignar

const Camaras = () => {
    const navigate = useNavigate();
    const location = useLocation(); 

    const [openCamara, setOpenCamara] = useState(false);
    const [camaraKey, setCamaraKey] = useState(0);
    const [openAsignar, setOpenAsignar] = useState(false);


    const handleGoToClients = () => {
        navigate('/clientes');
    };

        const handleGoToubication = () => {
        navigate('/ubicaciones');
    };

    const handleForceCameraRestart = useCallback(() => {
        setOpenCamara(false);
        setCamaraKey(prevKey => prevKey + 1);
        setTimeout(() => {
            setOpenCamara(true);
        }, 50);
    }, []);

    // Componente reutilizable para cada bloque de acción
    const ActionBlock = ({ title, description, icon, buttonLabel, onClick, color, sxButton = {} }) => (
        <Paper 
            elevation={2} 
            sx={{ 
                p: 3, 
                flex: 1, 
                minWidth: '200px',
                textAlign: 'center', 
                m: 1, 
                transition: '0.3s',
                '&:hover': { transform: 'translateY(-4px)', boxShadow: 6 },
                borderTop: `4px solid ${color}`
            }}
        >
            <Box sx={{ color: color, mb: 1 }}>
                {icon}
            </Box>
            <Typography variant="h6" gutterBottom color="textPrimary">
                {title}
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 2, height: '40px' }}>
                {description}
            </Typography>
            <Button 
                variant="contained" 
                startIcon={icon}
                onClick={onClick}
                sx={{ 
                    bgcolor: color, 
                    '&:hover': { bgcolor: color, opacity: 0.9 },
                    ...sxButton 
                }}
            >
                {buttonLabel}
            </Button>
        </Paper>
    );

    return (
        <Box sx={{ p: 3, pt: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', bgcolor: '#f5f5f5' }}>
            <Paper elevation={4} sx={{ p: 5, textAlign: 'center', maxWidth: 900, borderRadius: 2 }}>
                
                <Box sx={{ mb: 3 }}>
                    <img 
                        src={qrIcon}
                        alt="Gestión de Pacientes"
                        style={{ width: '450px', height: '250px', objectFit: 'contain' }}
                    />
                </Box>
                
                <Typography variant="h4" color={PRIMARY_COLOR} gutterBottom sx={{ fontWeight: 600 }}>
                    Busqueda Paciente - Asignacion Sala Localización Pacientes
                </Typography>
                
                <Typography variant="body1" color="textSecondary" sx={{ mb: 4 }}>
                    Selecciona la opción para **Escanear** y Abrir la ficha del paciente o **Asignar** la ubicación del paciente.
                </Typography>
                
                {/* Contenedor Flex para los botones separados */}
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'center', gap: 2, mb: 4 }}>

                    {/* BLOQUE 1: Escanear QR */}
                    <ActionBlock
                        title="Escanear QR"
                        description="Utiliza la cámara para leer el código QR del paciente y abrir su ficha ."
                        icon={<QrCodeIcon />}
                        buttonLabel="Iniciar Escaneo QR"
                        onClick={() => setOpenCamara(true)}
                        color={SUCCESS_COLOR}
                        sxButton={{
                            '&:hover': { bgcolor: '#059669' } // Darker green on hover
                        }}
                    />

                    {/* BLOQUE 2: Asignar Ubicación */}
                    <ActionBlock
                        title="Ubicasión de paciente en sala"
                        description="Utiliza la cámara para leer el código QR de la sala y  QR del paciente."
                        icon={<LocationOnIcon />}
                        buttonLabel="Asignar Ubicación sALA"
                        onClick={() => setOpenAsignar(true)}
                        color={WARNING_COLOR}
                        sxButton={{
                            '&:hover': { bgcolor: '#d97706' } // Darker yellow/orange on hover
                        }}
                    />

                </Box>

                {/* Modales (se mantienen) */}
                <AsignarUbicacionPaciente 
                    open={openAsignar} 
                    handleClose={() => setOpenAsignar(false)} 
                />
                <BusquedaCamaraPaciente
                    key={camaraKey} 
                    open={openCamara}
                    handleClose={() => setOpenCamara(false)}
                    navigate={navigate}
                    onForceRestart={handleForceCameraRestart} 
                />

                {/* Botón Volver a Clientes */}
                <Button 
                    variant="outlined" // Cambiado a outlined para menos prominencia que las acciones principales
                    color="primary" 
                    onClick={handleGoToClients}
                    sx={{ mt: 2 }} 
                >
                    Volver a Clientes
                </Button>

                {/* Botón Volver a Clientes */}
                <Button 
                    variant="outlined" // Cambiado a outlined para menos prominencia que las acciones principales
                    color="primary" 
                    onClick={handleGoToubication}
                    sx={{ mt: 2 }} 
                >
                    Ver Ubicaciones
                </Button>

            </Paper>
        </Box>
    );
};

export default Camaras;